import * as angular from "angular";
import { enumOptions } from "../runtime";
import type { ChoiceOption } from "../types";
import type { ControlState } from "./control-state";
import choiceControl from "./choice-control";
import template from "./enum-control.html";

export interface EnumControlController {
	control: ControlState;
}

// AngularJS assigns bindings before constructing the controller.
// eslint-disable-next-line no-redeclare
export class EnumControlController implements angular.IController {
	public choices: ReturnType<typeof enumOptions> = [];

	public $onChanges(): void {
		this.choices = enumOptions(this.control.schema);
	}

	public change(value: ChoiceOption["value"]): void {
		this.control.change(value);
	}
}

export default angular.module("vesl.extensions.json-schema.enum-control", [choiceControl])
	.component("jsonSchemaEnumControl", {
		template,
		controller: EnumControlController,
		bindings: { control: "<" }
	})
	.name;
